import { render, staticRenderFns } from "./customer-market.vue?vue&type=template&id=c8e1cb5c&"
import script from "./customer-market.vue?vue&type=script&lang=js&"
export * from "./customer-market.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports